import React from 'react';

import type * as GroupSelectionsTypes from '../../../state/views/groupSelections/types';
import {
  MoveRunDrawerContents,
  type RunDrawerRun,
} from './MoveRunDrawerContents';
import {Drawer} from './MoveRunDrawerPieces';

type MoveRunDrawerProps = {
  entityName: string;
  onClose: () => void;
  /** called when move runs process completes. does not fire on failure. */
  onMovedRuns: () => void;
  open: boolean;
  projectName: string;
  runs: RunDrawerRun[];
  groupSelectionsRef: GroupSelectionsTypes.Ref;
  selectedCount: number;
};
export function MoveRunDrawer({
  entityName,
  open,
  onClose,
  onMovedRuns,
  projectName,
  runs,
  groupSelectionsRef,
  selectedCount,
}: MoveRunDrawerProps) {
  return (
    <Drawer open={open} onClose={onClose}>
      <MoveRunDrawerContents
        entityName={entityName}
        onClose={onClose}
        onMovedRuns={onMovedRuns}
        projectName={projectName}
        runs={runs}
        groupSelectionsRef={groupSelectionsRef}
        selectedCount={selectedCount}
      />
    </Drawer>
  );
}
